<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Lookup" />

    <div class="upload-template">
        <input type="file" multiple @change="onFileChange" />
        <button :disabled="!files.length || loading" @click="uploadFiles">Upload</button>
        <div v-if="loading">Uploading...</div>
        <div v-if="message" :class="{ success: success, error: !success }">{{ message }}</div>
        <ul v-if="uploadedFiles.length">
        <li v-for="(file, idx) in uploadedFiles" :key="idx">
            {{ file.originalName }} ({{ file.size }} bytes)
        </li>
        </ul>
    </div>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
  name: 'UploadTemplate',
  components: {
    IndexBase
  },
  data() {
    return {
      files: [],
      loading: false,
      message: '',
      success: false,
      uploadedFiles: [],
      url: this.$API_URL + "Upload/uploadToDirectory/"
    };
  },
  methods: {
    onAuth(event) {
      if (!event.canUpload)
        this.$router.push({ name: 'Denied' });
    },
    onFileChange(e) {
      this.files = Array.from(e.target.files);
      this.message = '';
      this.uploadedFiles = [];
    },
    async uploadFiles() {
      if (!this.files.length) return;
      
      this.loading = true;
      this.message = '';
      this.success = false;
      
      const formData = new FormData();
      this.files.forEach(f => formData.append('file', f, f.name));
      formData.append("modul", JSON.stringify(this.Title));
      
      try {
        const response = await this.$axios.post(this.url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 7000000
        });
        
        if (response.data.success) {
          this.success = true;
          this.message = response.data.message;
          this.uploadedFiles = response.data.data || [];
        } else {
          this.success = false;
          this.message = response.data.message;
        }
      } catch (error) {
        this.success = false;
        this.message = 'Upload failed: ' + error.message;
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.upload-template { max-width: 400px; margin: 20px auto; }
.success { color: green; }
.error { color: red; }
</style>
